<div>
    <strong>Min</strong>
    <mat-slider min="10" max="20" step="2" value="14" class="slider" (input)="onChangeSlider($event)"></mat-slider>
    <strong>Max</strong>
</div>